import { Component, Inject } from '@angular/core';
import { BinariesService } from '@services/binaries/binaries.service';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { PackService } from '@services/pack/pack.service';
import { NotificationManagerService } from '@shared/services/notification-manager.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PackLite } from '@shared/models/generic/pack-lite.model';
import { hasTargetDomainForBinaries } from '@packs/utils/pack.utils';

@Component({
  selector: 'app-edit-pack-name-popin',
  templateUrl: 'edit-pack-name-popin.component.html',
  standalone: false,
})
export class EditPackNamePopinComponent {
  formPack = this.formBuilder.group({});
  applianceGroups = [];
  pack: PackLite;
  isSubmitted = false;

  constructor(
    private readonly packService: PackService,
    private readonly translateService: TranslateService,
    private readonly notificationManagerService: NotificationManagerService,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly binariesService: BinariesService,
    public dialogRef: MatDialogRef<EditPackNamePopinComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      pack: PackLite;
    },
  ) {
    this.pack = data.pack;
    this.formPack = this.formBuilder.group({
      title: [data.pack.title, Validators.minLength(1)],
    });
  }

  cancel(): void {
    this.dialogRef.close();
  }

  submitSelection(): void {
    if (this.formPack.invalid) {
      return;
    }
    this.pack.title = this.formPack.controls.title.value;
    this.pack.name[this.pack.market][this.pack.lang] = this.pack.title;
    this.packService.updatePack(this.pack).subscribe(
      () => {
        this.isSubmitted = false;
        this.notificationManagerService.displaySuccess(this.translateService.instant('REFDATA.PACKS.MSG.SUCCESS.UPDATE'));
        this.dialogRef.close(this.pack);
      },
      (err) => this.notificationManagerService.displayHttpError(err),
    );
  }

  bineratorLenghtTestOnFocus(propertyName: string): void {
    // call when lost focus
    if (this.pack.lang === 'ar') {
      this.bineratorFieldLengthValid(propertyName);
    }
  }

  bineratorLenghtTest(propertyName: string): void {
    if (this.pack.lang !== 'ar') {
      this.bineratorFieldLengthValid(propertyName);
    }
  }

  bineratorFieldLengthValid(propertyName: string): void {
    if (hasTargetDomainForBinaries(this.pack)) {
      this.binariesService
        .isFieldLengthValid(this.pack.market, this.pack.lang, propertyName, this.formPack.controls[propertyName].value)
        .subscribe((isValid: any) => {
          if (isValid) {
            this.formPack.controls[propertyName].setErrors(null);
          } else {
            this.formPack.controls[propertyName].setErrors({ binerator: true });
          }
        });
    }
  }
}
